<div class="title" mat-dialog-title>Add Client ID & Secret</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to ask your Taboola Account Manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Client ID</mat-label>
                <input matInput placeholder="Enter Client ID " formControlName="clientId" data-cy="taboola-client-id-input">
                <mat-error
                    *ngIf="connectionForm.get('clientId').errors && (connectionForm.get('clientId').touched || connectionForm.get('clientId').dirty)">
                    Invalid Client ID</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Secret</mat-label>
                <input type="password" matInput placeholder="Enter Client Secret" formControlName="clientSecret" data-cy="taboola-client-secret-input">
                <mat-error
                    *ngIf="connectionForm.get('clientSecret').errors && (connectionForm.get('clientSecret').touched || connectionForm.get('clientSecret').dirty)">
                    Invalid Client Secret</mat-error>
            </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="taboola-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>